import React from 'react'
import './components.css'


const FAQ = () =>{

    return(
        <div className="mutualaid-container">
        <div className="mutualaid">
            <h2>What is Mutual Aid?</h2>
            <p>Mutual Aid is a voluntary
            reciprocal exchange of resources and
            services for mutual benefit. Mutual Aid
            projects are a form of participation in
            which people take responsibility for
            caring for one another.</p>

            <h2>What is a Community Fridge?</h2>
            <p>
                A community fridge operates on a
                take what you need, leave what you
                can, no questions asked basis.
              
                The goal of a community fridge is to
                fight food insecurity. It is a mutual aid,
                not a charity, ANYONE can take from
                this fridge.
            </p>
            <h3>Food is a basic human right and
everyone deserves access.</h3>
        </div>
        </div>
    )
}

export default FAQ